var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 52,
    viewBox: "0 0 23 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.21 14.5994C19.69 14.5794 16.29 14.5794 12.03 14.5794H1.80998V6.51941H12.03C15.84 6.51941 19.39 6.5094 22.21 6.4894V6.10942C19.33 6.08942 15.69 6.07942 11.74 6.07942H1.22998V15.1494H11.74C16.16 15.1494 19.65 15.1494 22.21 15.1294V14.5994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 43.9196L17.42 49.2596L12.48 49.2696H7.56998L7.76998 48.8096C7.86998 48.5496 8.52998 47.0996 9.21998 45.5996C17.94 26.5996 21.45 19.4296 22.52 16.9096L22.29 16.4496C21.56 17.9196 19.77 21.3796 17.81 25.6796C15.39 30.9296 12.04 38.2496 10.34 41.9296C8.63998 45.6196 7.12998 48.8996 6.98998 49.2296L6.72998 49.8496H17.76L20.02 44.7196C21.22 41.9996 22.22 39.9496 22.75 38.7596H22.31C21.72 39.7996 20.87 41.5096 19.8 43.9196Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 51.2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.947026473a9aa7e369819821b91d1b8b.svg";
export { ForwardRef as ReactComponent };